import React, { useEffect, useState } from 'react'
import {IoIosPersonAdd } from 'react-icons/io';
import { RotatingLines } from 'react-loader-spinner';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../context/Auth';
import ExportData from '../../../components/ExportData';

const PrintSessionSalesReport = () => {
  const [searchParams] = useSearchParams();
  const session = searchParams.get("session");
  const date = searchParams.get("date");
  
  const { requestWithAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [sessionSales, setSessionSales] = useState([]);
  const [tableData, setTableData] = useState([])
  const [totalSales, setTotalSales] = useState(0.00);


  const getSessionSales = async () => {
    
    try {
      setLoading(true);
      const data = await requestWithAuth(
        `/report/session-sales/${date}?session=${session}`,
        "GET"
      );
      setSessionSales(data?.branches);
      setTotalSales(data?.total_sales_all_branches)
      setTableData(data?.branches)
    } catch (error) {
      setSessionSales(null)
    } finally {
      setLoading(false);
    }
  };

  



  

  useEffect(() => {
    getSessionSales();
  }, []);

  
  return (
    <div className="p-[20px]">
        <div className="py-[32px] flex items-center justify-between ">
        <div className="flex items-center gap-3">
          <IoIosPersonAdd className="text-[19px]" />
          <h4 className="text-[19px]">
            <b>Report </b> - Session Sales  
          </h4>
        </div>
        
      </div>

      <div className="border border-[#ddd] bg-white">
        <div className="p-[20px]">
            <h5 className="my-[2px] text-[17px]">Session Sales Report</h5>
        </div>
        <div className="p-[20px]">
            <div className="p-[20px] border border-[#ddd]">
                <div className="pt-[20px] flex lg:flex-row flex-col justify-between mb-[20px]">
                    <div className=" flex items-center gap-5">
                    <ExportData tableData={tableData} fileName="Expense Report" />
                    
                    </div>
                    
                </div>
                <div className="overflow-auto ">
                    <table className="border-collapse w-full text-left">
                    <thead>
                        <tr className='text-left'>
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Branch Name
                        </th>
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Customers Served
                        </th>
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Total Sales
                        </th>
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Items Sold
                        </th>
                        
                        
                        </tr>
                    </thead>
                    {!loading && (
                        <tbody>
                        {sessionSales?.map((item, index) => (
                            <tr key={index} className="text-left">
                            
                            <td className=" border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.branch}
                            </td>
                            <td className="  border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.customers_served}
                            </td>
                            <td className=" border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.total_sales}
                            </td>
                            <td className=" border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.items_sold}
                            </td>
                            
                            </tr>
                        ))}
                        <tr className="font-bold">
                            <td colSpan={2} className="border-b border-[#bbb] py-[12px] px-[20px]">
                            Total Sales
                            </td>
                            <td colSpan={2} className="border-b border-[#bbb] py-[12px] px-[20px]">
                            {totalSales}
                            </td>
                            
                        </tr>
                        </tbody>
                    )}
                    
                    </table>
                    {loading && (
                    <div className="flex items-center justify-center py-10">
                        <RotatingLines
                        visible={true}
                        height="30"
                        width="30"
                        color="black"
                        strokeColor="black"
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        />
                    </div>
                    )}
                    {sessionSales?.length <= 0 && !loading && (
                    <p className="text-center py-5">No data availabe in table</p>
                    )}
                    
                </div>
            </div>
        </div>
      </div>

    </div>
  )
}

export default PrintSessionSalesReport